document.addEventListener('crPickupActivated', function (e) {
    console.log('------- Activated ------')
    setTimeout(function(){
        jqCR("#CartTerms").rules('add', {
            "required": true,
            "messages": {
                "required": "You must agree with the terms and conditions of sales to check out"
            }
        });  
    }, 500)
    
})
